import { Box } from "@material-ui/core"
import L from "leaflet"
import { createRef, useEffect } from "react"
import type { ReactElement, RefObject } from "react"
import { connect } from "react-redux"
import type { Dispatch } from "redux"
import { changeColor } from "../../../redux"
import type { AppState } from "../../../redux"

import "./color-swatch-panel.styles.scss"
import { useTracker } from "../../../hooks/useTracker"
import { AnalyticsElementModule } from "../../../models"

export interface IColorSwatchPanelStateProps {
  color: string
  setColor: (color: string) => void
}

function ColorSwatchPanelView(props: IColorSwatchPanelStateProps): ReactElement {
  const { color, setColor } = props
  const tracker = useTracker()
  const ref: RefObject<HTMLDivElement> = createRef<HTMLDivElement>()

  useEffect(() => {
    if (ref.current) {
      L.DomEvent.disableClickPropagation(ref.current)
    }
  }, [ref])

  function selectColor(selectedColor: string): void {
    tracker.elementClicked({
      module: AnalyticsElementModule.MapDrawingColorPicker,
      itemId: selectedColor,
      type: "button",
      elementId: "draw-control-picker"
    })
    setColor(selectedColor)
  }

  const colors: string[] = [
    "#C4C4C4",
    "#FFE600",
    "#08CF4C",
    "#FFFFFF",
    "#FFAF13",
    "#00E0FF",
    "#777777",
    "#FF0000",
    "#009FE3",
    "#000000",
    "#6D00DB",
    "#0030DB"
  ]

  return (
    <div ref={ref} className="color-swatch-panel">
      {colors.map((selectableColor: string, index: number) => (
        <Box
          // biome-ignore lint/suspicious/noArrayIndexKey: TODO in a later PR
          key={index}
          className={`color-swatch ${selectableColor === color ? "selected" : ""}`}
          style={{ backgroundColor: selectableColor }}
          onClick={() => selectColor(selectableColor)}
        />
      ))}
    </div>
  )
}

function mapStateToProps(state: AppState) {
  return {
    color: state.colorPicker.color
  }
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    setColor: (color: string) => dispatch(changeColor(color))
  }
}

export const ColorSwatchPanel = connect(mapStateToProps, mapDispatchToProps)(ColorSwatchPanelView)
